import moment from 'moment'

/**
 * List of available formats
 * @type {{
 *   short: string,
 *   full: string,
 *   time: string
 * }}
 */
export const DATE_FORMATS = {
  short: 'DD-MM-YYYY',
  full: 'DD-MM-YYYY HH:mm:ss',
  time: 'HH:mm',
}

/**
 * Format date
 *
 * @param {number|string} unixtime
 * @param {string} format
 * @param {boolean} [utc=false] - format in UTC instead of the local timezone
 * @return {null|string}
 */
export function toDate(unixtime, format, utc = false) {
  if (unixtime) {
    let frm
    if (Object.keys(DATE_FORMATS).includes(format)) {
      frm = DATE_FORMATS[format]
    } else {
      frm = format
    }

    return (utc ? moment.utc(unixtime) : moment(unixtime)).format(frm)
  }

  return null
}

/**
 * Unix timestamp limits for date inputs
 * MIN_TIMESTAMP: GMT: Friday, December 13, 1901 8:45:52 PM
 * MAX_TIMESTAMP: GMT: Tuesday, January 19, 2038 3:14:07 AM
 * @type {{
 *   MIN_TIMESTAMP: number,
 *   MAX_TIMESTAMP: number
 * }}
 */
export const DATE_INPUT_LIMITS = {
  MIN_TIMESTAMP: -2147483648000,
  MAX_TIMESTAMP: 2147483647000,
}
